import { createContext, useContext } from 'react';

import { UseScalesResult } from '@components/patterns/LineChart/use-scales';

import {
  LineChartAnnotation,
  LineChartData,
  LineChartSeries,
  Measurement,
} from './types';

export interface LineChartContextValue<
  Data extends LineChartData,
  Annotation extends LineChartAnnotation,
> {
  series: LineChartSeries<Data, Annotation>[];
  rect: Measurement;
  scales: UseScalesResult;
}

export const LineChartContext = createContext<LineChartContextValue<
  LineChartData,
  LineChartAnnotation
> | null>(null);

export function useLineChartContext<
  Data extends LineChartData,
  Annotation extends LineChartAnnotation = LineChartAnnotation,
>() {
  const context = useContext(LineChartContext);
  if (!context) {
    throw new Error(
      'useLineChartContext must be used within a LineChartContext'
    );
  }
  return context as LineChartContextValue<Data, Annotation>;
}
